/* eslint-disable no-console */
import { put, takeEvery, select } from 'redux-saga/effects';
import { closeModal } from 'actions/modal';

// Api
import { updateNotes, setNotes } from 'api/notes';

// Actions
import { getNotes as getNotesAction } from 'actions/notes';
import { startEditNotesSubmit, resolveEditSubmit } from './actions';

export function* editNotesSaga({ payload }: any) {
  const { token } = yield select(state => state.user);
  const { candidateId, noteId, notes } = payload;

  try {
    if (noteId) {
      yield updateNotes(notes, noteId, token);
    } else {
      yield setNotes(notes, candidateId, token);
    }

    yield put(getNotesAction(token));

    yield put(resolveEditSubmit());
    yield put(closeModal());
  } catch (error) {
    yield put(resolveEditSubmit(error.response));
  }
}

export default function* editNotesSagas() {
  yield takeEvery(startEditNotesSubmit, editNotesSaga);
}
